import * as React from "react";
import { Table} from "antd";
import { connect } from "react-redux";
//import moment from "moment";

interface ILoglistProps {
  id:any;
  loglist:any;
  tabStatus:any;
}

// 修改
class Loglist extends React.Component<ILoglistProps, any> {
  state = {
     list:[],
     refresh:true,
  };
  constructor(props: ILoglistProps) {
    super(props);
  }

  componentDidMount() {
    this.loglist();     
  }

  shouldComponentUpdate(nextProps: any, prevState: any) {
    if(nextProps.tabStatus != 'tab6' && !prevState.refresh ){
      this.setState({
        refresh: true,
      });
      return true;
    }
    if(nextProps.tabStatus == 'tab6' && prevState.refresh ){
      this.loglist();
      return false;
    }
    return true;
  }

  loglist = () =>{
    this.setState({
      refresh: false,
    });
    const param: any = {
      id: this.props.id
    }; 
    this.props.loglist({
      ...param,
      callback: (data) => {
        this.setState({
           list: data
        });
      }
     });    
  }

  render() {
    const dataSource = this.state.list;
    
    const columns = [{
      title: '时间',
      dataIndex: 'create_time',
      key:'create_time',
      className:'th',
      width: 200,
    }, {
      title: '操作人',
      dataIndex: 'operator',
      key:'operator',
      className:'th',
      width: 200,
    }, {
      title: '内容',
      dataIndex: 'logs',
      key:'logs',
      className:'th',
      render: (text, row, index) => {
        return (
          <React.Fragment>
                <div dangerouslySetInnerHTML={{__html: row.logs}} />
          </React.Fragment>
        );
      }
    }];

    
    return (
      <React.Fragment>
           <div className="from-email"> 
                   <Table bordered={true} expandIconAsCell={false} expandIconColumnIndex={-1} pagination={false} dataSource={dataSource} columns={columns} />
           </div>
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  id: state.orderDetails.id,
  tabStatus: state.orderDetails.tabStatus,
});

const mapDispatch = dispatch => {
  return {
    loglist: dispatch.orderDetails.loglist,
  };
};


export default connect(
  mapState ,
  mapDispatch
)(Loglist);
